// src/ecrans/reglages/reglages-calculs.js — Les blocs de « Société » (pur,
// testé). `ok` : true réglé, false à compléter, null inconnu (« — », jamais
// « réglé » par défaut). Mots de la maquette v677 (relevé 266).

import { analyserCompletude } from "../../lib/config-completude";

/**
 * Les deux nombres du bandeau « Ce qui manque », ou null si l'audit échoue.
 * Seuls ces nombres entrent dans l'écran ; l'audit (535 lignes, client) n'a pas
 * d'équivalent serveur et n'est pas recopié (une seule copie).
 */
export function compterManques(cfg) {
  try {
    const { compteurs } = analyserCompletude(cfg);
    return { bloquants: compteurs.bloquant, silencieux: compteurs.silencieux };
  } catch (e) {
    return null;
  }
}

function apercuIdentite(i) {
  const tva = i.tva_assujetti ? `TVA ${i.tva_taux ?? "—"} %` : "TVA non applicable";
  return `${i.nom || "—"} · SIRET ${i.siret || "—"} · ${tva}`;
}

/** L'espace voyageur, d'après `journey_composition_get`. */
function blocEspace(espace) {
  if (!espace || espace.etat === "lecture") return { ok: null, apercu: "On lit…" };
  if (espace.etat !== "ok") return { ok: null, apercu: "— lecture impossible" };
  const exceptions = (espace.data.overrides || []).filter((o) => o && o.active).length;
  return {
    ok: true,
    apercu: exceptions
      ? `${exceptions} exception${exceptions > 1 ? "s" : ""} par logement`
      : "réglage général · aucune exception",
  };
}

export function blocsSociete(r, espace) {
  const i = r.identite;
  const esp = blocEspace(espace);
  return [
    {
      id: "identite", ic: "◈", t: "L'identité", ok: Boolean(i.nom && i.siret && i.adresse),
      apercu: apercuIdentite(i), ancien: "general", geste: "modifier",
      champs: [["Nom", i.nom], ["SIRET", i.siret], ["Adresse", i.adresse], ["Adresse de contact", i.email], ["Téléphone", i.telephone]],
    },
    {
      id: "carte", ic: "⚖", t: "La carte professionnelle (carte G)", ok: null,
      apercu: r.carte_g || "—", ancien: "general", geste: "voir la société",
      note: "— L'appli ne garde pas encore la carte G.",
    },
    {
      id: "banque", ic: "€", t: "La banque", ok: r.banque_renseignee,
      apercu: r.banque_renseignee ? "IBAN et BIC renseignés" : "à renseigner", ancien: "general", geste: "modifier",
    },
    {
      id: "taxe", ic: "▤", t: "La taxe de séjour", ok: null, apercu: "—", ancien: "completude", geste: "voir les barèmes",
    },
    {
      id: "mediateur", ic: "!", t: "Le médiateur de la consommation", ok: r.mediateur.renseigne,
      apercu: r.mediateur.renseigne ? r.mediateur.nom : "non renseigné — l'article 16 disparaît des contrats de la Maison Zen",
      ancien: "general", geste: "modifier",
    },
    {
      id: "pied", ic: "☰", t: "Le pied des livrets", ok: true,
      apercu: r.pied_personnalise ? "personnalisé" : "vide — les valeurs par défaut de votre société s'affichent",
      ancien: "general", geste: "modifier",
    },
    {
      id: "espace", ic: "⌂", t: "L'espace voyageur, par plateforme", ok: esp.ok, apercu: esp.apercu,
      ancien: "general", geste: "modifier",
    },
    {
      id: "factures", ic: "▦", t: "Les factures", ok: null, apercu: "—", ancien: "general", geste: "voir les compteurs",
    },
  ];
}

export function bilanBlocs(blocs) {
  return {
    faits: blocs.filter((b) => b.ok === true).length,
    manquants: blocs.filter((b) => b.ok === false).map((b) => b.t),
    inconnus: blocs.filter((b) => b.ok === null).length,
  };
}
